import { render, staticRenderFns } from "./extension.vue?vue&type=template&id=04f874b5&scoped=true&"
import script from "./extension.vue?vue&type=script&lang=js&"
export * from "./extension.vue?vue&type=script&lang=js&"
import style0 from "./extension.vue?vue&type=style&index=0&id=04f874b5&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f874b5",
  null
  
)

export default component.exports